// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


const requiredPart = t.interface({
  tag: t.string,
});

export const ValidateOrganizationBindingAdminBaseObjectSchema = excess(requiredPart);

export interface ValidateOrganizationBindingAdminBaseObject extends t.TypeOf<typeof ValidateOrganizationBindingAdminBaseObjectSchema> {}
